module.exports = __webpack_public_path__ + "static/img/card_2_12.d66db7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_2_12.png
// module id = GKqX
// module chunks = 0